import { render, staticRenderFns } from "./templateConfigDetail.vue?vue&type=template&id=27aef420&scoped=true"
import script from "./templateConfigDetail.vue?vue&type=script&lang=js"
export * from "./templateConfigDetail.vue?vue&type=script&lang=js"
import style0 from "./templateConfigDetail.vue?vue&type=style&index=0&id=27aef420&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27aef420",
  null
  
)

export default component.exports